var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('confirm-dialog',{attrs:{"display":_vm.displayModal,"message":_vm.$t('page.selection.confirm.message')},on:{"accepted":function($event){return _vm.confirmLeaving()},"cancelled":function($event){return _vm.abortLeaving()}}})
}
var staticRenderFns = []

export { render, staticRenderFns }